/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Api_Transfer_Order_FailedInputs */

const fr_api_transfer_order_failed = /** @type {(inputs: Api_Transfer_Order_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ordre de virement non émis. Réessayez depuis la facture concernée.`)
};

const en_api_transfer_order_failed = /** @type {(inputs: Api_Transfer_Order_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transfer order not issued. Try again from the affected invoice.`)
};

/**
* | output |
* | --- |
* | "Transfer order not issued. Try again from the affected invoice." |
*
* @param {Api_Transfer_Order_FailedInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const api_transfer_order_failed = /** @type {((inputs?: Api_Transfer_Order_FailedInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Transfer_Order_FailedInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_api_transfer_order_failed(inputs)
	return fr_api_transfer_order_failed(inputs)
});